import { UseFormReturn, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object, string } from 'yup';
import { useTranslation } from 'react-i18next';

type FormValues = {
  email: string;
};

type Form = UseFormReturn<FormValues>;

type UseFormViewModel = () => Pick<Form, 'control' | 'handleSubmit'> & {
  isValid: Form['formState']['isValid'];
  errors: Form['formState']['errors'];
  email: string;
};

export const useFormViewModel: UseFormViewModel = () => {
  const { t } = useTranslation('common');
  const {
    control,
    formState: { errors, isValid },
    handleSubmit,
    getValues,
  } = useForm<FormValues>({
    mode: 'onBlur',
    resolver: yupResolver(
      object().shape({
        email: string().email(t('validation.email')).required(t('validation.required')),
      }),
    ),
  });

  return {
    control,
    errors,
    isValid,
    handleSubmit,
    email: getValues()['email'],
  };
};
